export const LANDING_AVATARS = {
  ana: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=160&h=160&fit=crop&crop=faces',
  marko: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=160&h=160&fit=crop&crop=faces',
  jovana: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=160&h=160&fit=crop&crop=faces',
  petar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=160&h=160&fit=crop&crop=faces',
};

export const HOW_IT_WORKS_PHOTOS = {
  search: {
    src: 'https://images.pexels.com/photos/8554276/pexels-photo-8554276.jpeg?auto=compress&cs=tinysrgb&w=800',
    alt: 'Roditelj pretražuje dadilje na telefonu',
  },
  contact: {
    src: 'https://images.pexels.com/photos/10029795/pexels-photo-10029795.jpeg?auto=compress&cs=tinysrgb&w=900',
    alt: 'Dve osobe u prijatnom razgovoru za stolom',
  },
  start: {
    src: 'https://images.pexels.com/photos/6974748/pexels-photo-6974748.jpeg?auto=compress&cs=tinysrgb&w=800',
    alt: 'Dadilja se igra i pazi decu',
  },
};
